// UI-layer wrapper around common/getCols that applies i18n translations to
// the `desc` field. Worker code continues to use common/getCols directly.
import { getCols as getColsBase } from "../../../../common/getCols.ts";
import type { Col } from "../components/DataTable/index.tsx";
import i18n from "./i18n.ts";

export const getCols = (
	titles: string[],
	overrides: Record<string, Partial<Col>> = {},
): Col[] => {
	return getColsBase(titles, overrides).map((col, i) => {
		const key = titles[i]!.replace(/:/g, "_");
		const translatedDesc = i18n.t(key, {
			ns: "cols",
			defaultValue: col.desc ?? "",
		});
		const translatedTitle =
			typeof col.title === "string"
				? i18n.t(`title.${key}`, {
						ns: "cols",
						defaultValue: col.title,
					})
				: col.title;
		return {
			...col,
			desc: translatedDesc,
			title: translatedTitle,
		};
	});
};
